import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { images } from '../data/mock';

const PartyRoom = () => {
  const { t } = useLanguage();

  return (
    <section className="bg-black py-16 md:py-24 animate-fade-in">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
          {/* Content */}
          <div className="order-2 lg:order-1">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-6 leading-tight">
              {t('partyTitle')}
            </h2>
            <p className="text-white/80 text-lg whitespace-pre-line leading-relaxed">
              {t('partyDesc')}
            </p>
          </div>
          
          {/* Image */}
          <div className="order-1 lg:order-2 relative overflow-hidden" style={{ aspectRatio: '4/3' }}>
            <img 
              src={images.indoor} 
              alt="Party Room"
              className="w-full h-full object-cover"
            />
            {/* Border accent */}
            <div className="absolute inset-0 border border-[#00FFD1]/30" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PartyRoom;